/**
 * Vue Google Autocomplete.
 *
 * A Vue.js (2.x) autosuggest component for the Google Maps Places API.
 *
 * https://github.com/olefirenko/vue-google-autocomplete
 *
 * @package Monapix
 * @version 3.0.1
 * @author Binary Cats Inc.
 */

import Vue from 'vue'
import VueGoogleAutocomplete from 'vue-google-autocomplete'

/**
 * @type {Object | null} Look up Google API Key in meta key
 */
let googleApiKey = document.head.querySelector('meta[name="google-api-key"]');

/**
 * @type {Object} Init sttings
 */
let settings = {}

/**
 * @type {Object} Init sttings
 */
if (googleApiKey) {
    settings.apiKey = googleApiKey.content
} else {
    console.error('Google API token not found');
}

Vue.use(VueGoogleAutocomplete, settings);
Vue.component('vue-google-autocomplete', VueGoogleAutocomplete)



// WEBPACK FOOTER //
// ./resources/js/services/vue-google-autocomplete.js